/**
 * Takes a total minutes value and splits it into
 * hours & remaining minutes
 */
export const minutesToHoursAndMinutes = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  return {
    hours,
    remainingMinutes: hours === 0 ? minutes : minutes - hours * 60,
  };
};
